module.exports = __webpack_public_path__ + "media/images/shush-c61f645edbd6d32f8629e14508bea4da.svg";